export default "__VITE_PUBLIC_ASSET__3f9ead9e__"